// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"8f9c9009","279":"462def3a"}[chunkId] + ".chunk.js";
};